//https://medium.com/@alexcambose/js-offsettop-property-is-not-great-and-here-is-why-b79842ef7582

export default {

	left: function(element) {
		let el = element;
		let offsetLeft = 0;
		while (el) {
			offsetLeft += el.offsetLeft;
			el = el.offsetParent;
		}
		return offsetLeft;
	},

	top: function(element) {
		let el = element;
		let offsetTop = 0;
		while (el) {
			offsetTop += el.offsetTop;
			el = el.offsetParent;
		}
		return offsetTop;
	}

};
